import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { STAGE_NAME } from './config';
import './styles/global.css';

// Capture referral code from URL and store in cookie (30-day expiry)
const urlParams = new URLSearchParams(window.location.search);
const referralParam = urlParams.get('referral');
if (referralParam) {
  const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `ws_referral=${encodeURIComponent(referralParam)};expires=${expires};path=/;SameSite=Lax`;
  // Clean URL (remove ?referral= param without page reload)
  urlParams.delete('referral');
  const cleanUrl = urlParams.toString()
    ? `${window.location.pathname}?${urlParams.toString()}`
    : window.location.pathname;
  window.history.replaceState({}, '', cleanUrl);
}

// Block indexing in non-prod environments
const stage = STAGE_NAME;
if (stage !== 'prod') {
  const meta = document.createElement('meta');
  meta.name = 'robots';
  meta.content = 'noindex, nofollow';
  document.head.appendChild(meta);
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
);
